
  import Vue from "vue";
  import Employment from "@/model/Employment";
  import EmployeeDetailsCardEmploymentsHistory from "@/views/Employee/details/EmployeeDetailsCardEmploymentsHistory.vue";
  import EmployeeDetailsCardListEntry from "@/views/Employee/details/EmployeeDetailsCardListEntry.vue";
  import EmployeeDetailsCardEmploymentsDialog from "./EmployeeDetailsCardEmploymentsDialog.vue";
  import EmploymentUtils from "@/views/Employee/details/EmploymentUtils";
  import Employee from "@/model/Employee";
  import EmployeeService from "@/service/EmployeeService";

  class ListEntry {
    public label: string;
    public text: string;
    public icon?: string;
  }

  export default Vue.extend({
    name: "EmployeeDetailsCardEmployments",
    components: {
      EmployeeDetailsCardListEntry,
      EmployeeDetailsCardEmploymentsHistory,
      EmployeeDetailsCardEmploymentsDialog
    },
    props: {
      editable: {
        type: Boolean,
        default: false
      },
      employee: {
        type: Employee,
        default: () => new Employee()
      }
    },
    data: () => ({
      dialog: false,
      employments: new Array<Employment>()
    }),
    computed: {
      getTemporary(): boolean {
        const temporary = this.employee.temporary;
        return temporary ? temporary : false;
      },
      employeeId (): number {
        return Number(this.$route.params.employeeId);
      },
      currentEmployment (): Employment {
        return EmploymentUtils.getCurrentEmployment(this.employments);
      },
      nextEmployment (): Employment | null {
        return EmploymentUtils.getNextEmployment(this.employments);
      },
      currentEmploymentListEntries (): Array<ListEntry> {
        const listEntries = new Array<ListEntry>();
        const employmentTypeI18N = this.currentEmployment.employmentType ? this.$vuetify.lang.t("$vuetify.enum.employmentType." + this.currentEmployment.employmentType) : "";
        const validFrom = this.$moment(this.currentEmployment.validFrom).format("MMMM YYYY");
        listEntries.push({ label: "Beschäftigungsart", text: employmentTypeI18N });
        listEntries.push({ label: "Gültig seit", text: validFrom });

        return listEntries;
      },
      nextEmploymentListEntries (): Array<ListEntry> {
        const listEntries = new Array<ListEntry>();
        if (this.nextEmployment) {
          const employmentTypeI18N = this.$vuetify.lang.t("$vuetify.enum.employmentType." + this.nextEmployment.employmentType);
          const validFrom = this.$moment(this.nextEmployment.validFrom).format("MMMM YYYY");
          listEntries.push({ label: "Beschäftigungsart", text: employmentTypeI18N });
          listEntries.push({ label: "Gültig ab", text: validFrom });
        }

        return listEntries;
      }
    },
    watch: {
      // The employee is reloaded after every change, so the employments are reloaded with it
      employee: {
        handler () {
          this.loadEmployments();
        },
        immediate: true
      }
    },
    methods: {
      loadEmployments () {
        if (this.employee.uuid) {
          EmployeeService.getEmployeeEmploymentsV3(this.employee.uuid)
            .then(employments => {
              this.employments = EmploymentUtils.fromEmploymentPeriodsV3(employments);
            });
        }
      }
    }
  });
